module.exports = __webpack_public_path__ + "img/t3-2.84b90d17.jpg";